import React, { useState } from "react";
import Box from "../../../components/Box";
import styled from "styled-components";
import Label from "../../../components/Label";
import CheckBoxDateRange from "./CheckBoxDateRange";
import LineChart from "../../../components/D3Charts/LineChart";
import { t } from "i18next";
import { Col, DatePicker, Flex, Row, Space } from "antd";
import Icon from "../../../components/Icon";
import { useSelector } from "react-redux";
import moment from "moment";
import DefaultModal from "../../../components/DefaultModal/DefaultModal";
const BoxContainer = styled(Box)`
  background: #f5f5f5;
  width: 160px;
  padding: 10px;
  border-radius: 8px;
  margin-left: 10px;
  height: 38px;
`;
const FinancialBoxShadow = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(40, 41, 61, 0.08),
    0px 20px 32px rgba(96, 97, 112, 0.24);
  border-radius: 30px;
  padding: 20px;
`;
const Graph = ({ title, dateRange, handleDateRange, dataSet, legends, colors }) => {
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const userType = useSelector((state) => state?.appReducer?.userType);
  const handleMonthChange = (date) => {
    if (date) {
      setMonth(date.month() + 1);
    }
  };
  const disabledYears = (current) => {
    const date = new Date(activeEntity.created_at);
    const minYear = moment(date).startOf("year");
    const maxYear = moment().endOf("year");
    return current && (current < minYear || current > maxYear);
  };

  const handleCSV = async () => {
    try {
      const payload = {
        month: month,
        year: year,
      };
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}admin/export-functionality`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log(res.data);
      setShowModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box width="100%" maxWidth="100%">
      <FinancialBoxShadow>
        <Flex className="pb-md-4 pb-2 px-3" gap="middle" wrap align="center" justify="space-between" horizontal>
          <Label fontSize="24px" fontWeight="700" justifyContent="center">
            {t(`${title}`)}
          </Label>
          {(userType === "admin") ? (
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
                width: "max-content",
                alignItems: "center",
              }}
            >
              <div className="col" style={{ width: "170px" }}>
                <label
                  htmlFor="Datum"
                  style={{
                    display: "block",
                    fontWeight: 500,
                    color: "#7E7E7E",
                    fontSize: "14px",
                  }}
                >
                  {t("Select Month")}
                  <span style={{ color: "#FE1717" }}>*</span>
                </label>
                <DatePicker.MonthPicker
                  className="input-box calendar"
                  placeholder={t("month")}
                  style={{ height: "40px" }}
                  // value={month && moment().month(month)}
                  onChange={handleMonthChange}
                  format="MMMM"
                  // disabledDate={disabledMonths}
                  suffixIcon={<Icon iconName="calendar" />}
                />
              </div>
              <div className="col" style={{ width: "170px" }}>
                <label
                  htmlFor="Datum"
                  style={{
                    display: "block",
                    fontWeight: 500,
                    color: "#7E7E7E",
                    fontSize: "14px",
                  }}
                >
                  {t("Select Year")}
                  <span style={{ color: "#FE1717" }}>*</span>
                </label>
                <DatePicker
                  className="input-box calendar"
                  placeholder={t("year")}
                  style={{ height: "40px" }}
                  onChange={(e) => setYear(e.$y)}
                  disabledDate={disabledYears}
                  picker="year"
                  suffixIcon={<Icon iconName="calendar" />}
                />
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "white",
                  background: " #D0004B",
                  borderRadius: "16px",
                  fontSize: "14px",
                  width: "90px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "28px",
                  gap: "5px",
                  marginTop: "20px",
                  pointerEvents: month && year ? "" : "none",
                }}
                onClick={handleCSV}
              >
                <Icon iconName="downloadWhite" />
                CSV
              </div>
            </div>
          ) : (
          dateRange &&  <label>
              <div style={{ flex: "right" }}>
                <BoxContainer>
                  <CheckBoxDateRange
                    value={dateRange}
                    handleSortBy={handleDateRange}
                  />
                </BoxContainer>
              </div>
            </label>
          )}
        </Flex>
        {console.log('dataSet>>>>>>>>>>>>>>>',dataSet)}
        <LineChart
          dataSet={dataSet}
          colors={colors}
          categories={[
            "Jan",
            "Feb",
            "Mrt",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dec",
          ]}
          xLabel="Month"
          yLabel="Amount"
          legends={legends}
          yAxisLabelFormat={(value) => value.toFixed(2)}
        />
      </FinancialBoxShadow>
      <DefaultModal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="congrats-modal"
        style={{ paddingRight: "0px" }}
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
        <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          <Label style={{ justifyContent: "center" }}>
            {t("The CSV has been sent to your registered E-mail addres")} !!
          </Label>
          <div className="d-flex justify-content-around mt-3">
            <button
              className="fill-bt"
              style={{ height: "46px" }}
              onClick={() => setShowModal(false)}
            >
              {t("Ja")}
            </button>
          </div>
        </div>
      </DefaultModal>
    </Box>
  );
};

export default Graph;
